import config from "config";

export const handleErrors = async function (response) {
  if (!response.ok) {
    const contentType = response.headers.get("content-type");
    let message = `${response.status}: ${response.statusText}`;

    if (contentType && contentType.includes("application/json")) {
      try {
        const body = await response.clone().json();
        if (body && (body.message || body.error)) {
          message = body.message || body.error;
        }
      } catch (_) {
        /* fall through to status text */
      }
    } else {
      try {
        const text = await response.clone().text();
        if (text && text.length < 2000 && !text.trim().startsWith("<")) {
          message = text;
        }
      } catch (_) {
        /* fall through */
      }
    }

    throw new Error(message);
  }
  return response;
};

function updateOptions(options) {
  const update = { ...options };
  if (localStorage.auth_token) {
    update.headers = {
      ...update.headers,
      Authorization: `Bearer ${localStorage.auth_token}`,
    };
  }
  return update;
}

export function fetcher(url, options) {
  return fetch(
    url.startsWith("/api") ? `${config.apiBaseUri}${url}` : url,
    updateOptions(options)
  );
}

export async function postData(url = "", data = {}) {
  return fetcher(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "omit", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *client
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  }).then(handleErrors);
}

export async function putData(url = "", data = {}) {
  return fetcher(url, {
    method: "PUT", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "omit", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *client
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  }).then(handleErrors);
}

export async function patchData(url = "", data = {}) {
  return fetcher(url, {
    method: "PATCH", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "omit", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *client
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  }).then(handleErrors);
}

export function fetchData(url, successCb, failureCb, finallyCb = () => {}) {
  fetcher(url)
    .then(handleErrors)
    .then((response) => response.json())
    .then(successCb)
    .catch(failureCb)
    .finally(finallyCb);
}

export function deleteRequest(url = "") {
  return fetcher(url, {
    method: "DELETE", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "omit", // include, *same-origin, omit
  }).then(handleErrors);
}
